export default "__VITE_ASSET__ZoZ6XqnO__"